import React from "react"

import * as style from "./Search.module.scss"

const Filter = ({ engine, microcopy }) => {
  const toggle = (type) => (event) => {
    engine.filter(type, event.target.checked)
  }

  return (
    <div className={style.filter}>
      <label>
        <input type="checkbox" defaultChecked onChange={toggle("Guide")} />
        <span />
        {microcopy.text("search.filter_types.guides")}
      </label>
      <label>
        <input type="checkbox" defaultChecked onChange={toggle("Endpoint")} />
        <span />
        {microcopy.text("search.filter_types.endpoints")}
      </label>
      <label>
        <input type="checkbox" onChange={toggle("Resource")} />
        <span />
        {microcopy.text("search.filter_types.resources")}
      </label>
      <label>
        <input type="checkbox" onChange={toggle("Param")} />
        <span />
        {microcopy.text("search.filter_types.params")}
      </label>
    </div>
  )
}

export default Filter
